import { useState, useRef, useEffect } from "react";
import { useForm, useFieldArray, Controller, set } from 'react-hook-form';
import Select from 'react-select';
import { useDempStore } from "src/context/stores";
import { cn } from 'src/lib/utils';
import AddItemPopup from "./AddItemPopup";
import { useSWRConfig } from 'swr'
import { useGetListCompany, createYearGroup, createItem, useGetListItems, deleteItem as deleteItemApi, updateItem, useGetOperations, deleteGroup as deleteGroupApi } from "../../services/useEsgApi";
import AddOperationPopup from "./AddOperationPopup";

const InfoPopupShowFormData = ({ isOpen, onClose }) => {
    const companyId = useDempStore((state) => state.companyId);
    const { mutateListCompany } = useGetListCompany(companyId);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const { mutate } = useSWRConfig()
    const { control, handleSubmit, register, formState: { errors }, reset } = useForm({
        defaultValues: {
            fields: [{
                // name: '',
                year: ''
            }]
        }
    });

    const { fields, append } = useFieldArray({
        control,
        name: 'fields'
    });

    const onSubmit = async (data) => {
        if (data && data.fields && data.fields[0]) {
            const groupData = data.fields[0];
           
            try {
                const apiData = {
                    year: groupData.year,
                };

                const response = await createYearGroup(apiData, companyId);
                // mutate(`/api/report/esg/${companyId}/years/`);

                if (response.error) {
                    setError("Failed to create year group. Please try again.");
                    console.error("API Error:", response.error);
                } else {
                    reset({ fields: [{  year: ''}] });
                    // mutate(`/api/report/esg/${companyId}/years/`);
                    mutateListCompany();
                    onClose();
                }
            } catch (err) {
                setError("An unexpected error occurred. Please try again.");
                console.error("Error creating year group:", err);
            } finally {
                setIsSubmitting(false);
            }
        }
    };

   
    useEffect(() => {
        if (isOpen) {
            reset({ fields: [{  year: '' }] });
            setError(null);
        }
    }, [isOpen, reset]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
            <div className="bg-white rounded-lg p-6 max-w-[800px] w-full mx-4 relative">
                <div className="flex items-center gap-4 mb-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] flex items-center justify-center">
                        <span className="text-2xl font-bold text-white">+</span>
                    </div>
                    <div>
                        <h3 className="text-xl font-bold">เพิ่มข้อมูล</h3>
                    </div>
                </div>

                <div className="p-4 mb-4 overflow-y-auto bg-gray-100 rounded-lg max-h-96">
                    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4" id="groupForm">
                        {fields.map((item, index) => (
                            <div key={item.id} className="p-4 space-y-4 bg-white border rounded-md">
                                {/* <div>
                                    <Controller
                                        name={`fields[${index}].name`}
                                        control={control}
                                        render={({ field }) => (
                                            <input {...field} type="text" className="w-full p-2 border rounded-md" placeholder="Please enter your group name:" />
                                        )}
                                    />
                                </div> */}
                                <div>
                                    <Controller
                                        name={`fields[${index}].year`}
                                        control={control}
                                        render={({ field }) => (
                                            <select {...field} className="w-full p-2 border rounded-md">
                                                <option value="">Year</option>
                                                <option value="2025">2025</option>
                                                <option value="2024">2024</option>
                                                <option value="2023">2023</option>
                                                <option value="2022">2022</option>
                                                <option value="2021">2021</option>
                                            </select>
                                        )}
                                    />
                                </div>
                                
                            </div>
                        ))}
                        
                        {error && (
                            <div className="p-3 text-sm text-red-700 bg-red-100 rounded-md">
                                {error}
                            </div>
                        )}
                    </form>
                </div>

                <div className="flex justify-end gap-4">
                    <button
                        onClick={onClose}
                        className="px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-700 text-white rounded-lg hover:opacity-90 transition-all font-medium"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        form="groupForm"
                        className="px-6 py-2.5 bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] text-white rounded-lg hover:opacity-90 transition-all font-medium"
                        disabled={isSubmitting}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

const sdGoals = [
    { id: 1, name: "No Poverty" },
    { id: 2, name: "Zero Hunger" },
    { id: 3, name: "Good Health and Well-being" },
    { id: 4, name: "Quality Education" },
    { id: 5, name: "Gender Equality" },
    { id: 6, name: "Clean Water and Sanitation" },
    { id: 7, name: "Affordable and Clean Energy" },
    { id: 8, name: "Decent Work and Economic Growth" },
    { id: 9, name: "Industry, Innovation and Infrastructure" },
    { id: 10, name: "Reduced Inequalities" },
    { id: 11, name: "Sustainable Cities and Communities" },
    { id: 12, name: "Responsible Consumption and Production" },
    { id: 13, name: "Climate Action" },
    { id: 14, name: "Life Below Water" },
    { id: 15, name: "Life on Land" },
    { id: 16, name: "Peace, Justice and Strong Institutions" },
    { id: 17, name: "Partnerships for the Goals" }
];

const getSubOptions = (esgType) => {
    switch(esgType) {
        case 'Environment':
            return [
                { value: 'E1', label: 'หมวดการจัดการสิ่งแวดล้อม' },
                { value: 'E2', label: 'หมวดการใช้ทรัพยากรอย่างมีประสิทธิภาพ' },
                { value: 'E3', label: 'หมวดการจัดการด้านสภาพภูมิอากาศ' }
            ];
        case 'Social':
            return [
                { value: 'S1', label: 'หมวดการเคารพสิทธิมนุษยชนและการปฎิบัติต่อแรงงานอย่างเป็นธรรม' },
                { value: 'S2', label: 'หมวดการพัฒนาศักยภาพแก่พนักงาน' },
                { value: 'S3', label: 'หมวดการจูงใจและรักษาพนักงาน' },
                { value: 'S4', label: 'หมวดสุขภาวะและความปลอดภัยในสภาพแวดล้อมการทำงาน' },
                { value: 'S5', label: 'หมวดการมีส่วนร่วมกับชุมชนและสังคม' },
                { value: 'S6', label: 'หมวดการมีส่วนร่วมของผู้มีส่วนได้เสีย' }
            ];
        case 'Governance & Economic':
            return [
                { value: 'G1', label: 'หมวดบรรษัทภิบาล' },
                { value: 'G2', label: 'หมวดจรรยาบรรณธุรกิจ ( Code of Conduct ) และการต่อต้านการทุจริต' },
                { value: 'G3', label: 'หมวดการระบุประเด็นที่เป็นสาระสำคัญของธุรกิจ ( Materiality )' },
                { value: 'G4', label: 'หมวดการบริหารความเสี่ยงและภาวะวิกฤต' },
                { value: 'G5', label: 'หมวดการบริหารจัดการความสัมพันธ์กับลูกค้า' },
                { value: 'G6', label: 'หมวดการบริหารจัดการห่วงโซ่อุปทาน' },
                { value: 'G7', label: 'หมวดการดำเนินการด้านภาษี' },
                { value: 'G8', label: 'หมวดนวัตกรรมทางธุรกิจเพื่อสังคมและ/หรือสิ่งแวดล้อม' },
                { value: 'G9', label: 'หมวดความปลอดภัยของข้อมูลและระบบสนเทศ' },
                { value: 'G10', label: 'หมวดการบริหารคุณภาพการให้บริการ' }
            ];
        default:
            return [];
    }
};


export default function ESGChart_dashboard() {
    const companyId = useDempStore((state) => state.companyId);
    const { listCompany, isLoadingListCompany, mutateListCompany } = useGetListCompany(companyId);
    const [selectedYear, setSelectedYear] = useState([]);
    // const [selectedOperationYear, setSelectedOperationYear] = useState(null);
    const { listItems } = useGetListItems(companyId, selectedYear.join(','));
    // const { operationsData } = useGetOperations(companyId,selectedOperationYear)
    
    const getYearData = (year) => {
        return listItems?.data?.[year] || [];
    };


    const getOperationData = (year) => {
        return listItems?.data?.[year]?.operations || null;
    };

    const hasOperationData = (year) => {
        const operationData = getOperationData(year);
        return operationData && Object.keys(operationData).length > 0;
    };
    
    

    const toggleYear = (yearIndex) => {
        setExpandedYears(prev => ({
            ...prev,
            [yearIndex]: !prev[yearIndex]
        }));
        
        if (listCompany?.years && listCompany.years[yearIndex]) {
            const year = listCompany.years[yearIndex];
            setSelectedYear(prev => {
                if (prev.includes(year)) {
                    return prev.filter(y => y !== year);
                }
                return [...prev, year].sort((a, b) => b - a);
            });
            // setSelectedOperationYear(year);
        }
    };

    const svgRef = useRef(null);
    const [isNewPopupOpen, setIsNewPopupOpen] = useState(false);
    const [isAddItemPopupOpen, setIsAddItemPopupOpen] = useState(false);
    const [isAddOperationPopupOpen, setIsAddOperationPopupOpen] = useState(false);
    const [currentGroupIndex, setCurrentGroupIndex] = useState(null);
    const [tooltip, setTooltip] = useState({
        visible: false,
        x: 0,
        y: 0,
        content: "",
    });

    const [expandedYears, setExpandedYears] = useState({});
    const [expandedItems, setExpandedItems] = useState({});
    const [editingItem, setEditingItem] = useState(null);
    const [expandedSections, setExpandedSections] = useState({});
    const [expendedOperations, setExpendedOperations] = useState(false);
    const [expandedTypes, setExpandedTypes] = useState({});
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [yearToDelete, setYearToDelete] = useState(null);
    // const { mutate } = useSWRConfig()
    
    const deleteGroup = async (yearIndex) => {
        try {
            const year = listCompany?.years?.[yearIndex];
            if (!year) {
                console.error("Year not found for index:", yearIndex);
                return;
            }

            const response = await deleteGroupApi({}, companyId, year);
            
            if (response.error) {
                console.error("Error deleting group:", response.error);
            } else {

                // mutate(`/api/report/esg/${companyId}/years/`);
                mutateListCompany();
                setSelectedYear(prev => prev.filter(y => y !== year));
                setTimeout(() => setSelectedYear(prev => [...prev, year].sort((a, b) => a - b)), 100);
            }
        } catch (error) {
            console.error("Error deleting group:", error);
        }
    };

    const openAddItemPopup = (yearIndex) => {
        setCurrentGroupIndex(yearIndex);
        setIsAddItemPopupOpen(true);
        setIsAddOperationPopupOpen(false);
    };

    const openAddOperationPopup = (yearIndex) => {
        setCurrentGroupIndex(yearIndex);
        setIsAddOperationPopupOpen(true);
        setIsAddItemPopupOpen(false);
    };
    

    const toggleItem = (yearIndex, itemIndex) => {
        setExpandedItems(prev => ({
            ...prev,
            [`${yearIndex}-${itemIndex}`]: !prev[`${yearIndex}-${itemIndex}`]
        }));
    };

    const handleEditItem = (yearIndex, item) => {
        setCurrentGroupIndex(yearIndex);
        setEditingItem(item);
        setIsAddItemPopupOpen(true);
    };

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (tooltip.visible) {
                setTooltip((prev) => ({
                    ...prev,
                    x: e.clientX,
                    y: e.clientY,
                }));
            }
        };

        window.addEventListener("mousemove", handleMouseMove);
        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };
    }, [tooltip.visible]);

    const deleteItem = async (yearIndex, itemIndex) => {
        try {
            const year = listCompany?.years?.[yearIndex];
            if (!year) {
                console.error("Year not found for index:", yearIndex);
                return;
            }

            const itemToDelete = getYearData(year)?.items?.[itemIndex];

            if (!itemToDelete) {
                console.error("Item not found for index:", itemIndex);
                return;
            }

            const apiData = {
                id:  itemToDelete.id
            };
            
            const response = await deleteItemApi(apiData, companyId, year,itemToDelete.id);
            
            if (response.error) {
                console.error("Error deleting item:", response.error);
            } else {
                setSelectedYear(prev => prev.filter(y => y !== year));
                setTimeout(() => setSelectedYear(prev => [...prev, year].sort((a, b) => a - b)), 100);
            }
        } catch (error) {
            console.error("Error deleting item:", error);
        }
    };

    const handleOperationSubmit = (year, data) => {
        // setOperationData(prev => ({
        //     ...prev,
        //     [year]: data
        // }));
    };

    const toggleSection = (yearIndex, section) => {
        setExpandedSections(prev => ({
            ...prev,
            [`${yearIndex}-${section}`]: !prev[`${yearIndex}-${section}`]
        }));
    };

    const handleEditOperation = (yearIndex) => {
        setCurrentGroupIndex(yearIndex);
        const year = listCompany?.years?.[yearIndex];
        const operationData = year ? getOperationData(year) : null;
        setEditingItem(operationData);
        setIsAddOperationPopupOpen(true);
    };

    const groupItemsByType = (items = []) => {
        return items.reduce((acc, item) => {
            if (!acc[item.esgType]) acc[item.esgType] = [];
            acc[item.esgType].push(item);
            return acc;
        }, {});
    };

    return (
        <div className="w-full h-full max-w-full min-h-screen p-4">

            <div className="flex items-center justify-between mb-6">
                <h1 className="text-2xl font-bold">ESG Dashboard</h1>
                <button
                    onClick={() => setIsNewPopupOpen(true)}
                    className="px-6 py-2.5 bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] text-white rounded-lg hover:opacity-90 transition-all font-medium"
                >
                    + Select Year
                </button>
            </div>

            {isLoadingListCompany ? (
                <div className="flex justify-center items-center h-40">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-vekin"></div>
                </div>
            ) : (
                <>
                    {[...(listCompany?.years || [])].sort((a, b) => b - a).map((year) => {
                        const yearIndex = listCompany.years.indexOf(year);
                        return (
                            <div key={`year-${year}`} className="mb-6">
                                <div 
                                    onClick={() => toggleYear(yearIndex)} 
                                    className="w-full p-4 text-white rounded shadow-md bg-vekin cursor-pointer"
                                >
                                    <div className="flex items-center justify-between w-full mb-4">
                                        <div className="flex items-center gap-4 cursor-pointer">
                                            <svg 
                                                className={`w-6 h-6 text-white transition-transform ${expandedYears[yearIndex] ? 'rotate-180' : ''}`}
                                                fill="none" 
                                                viewBox="0 0 24 24" 
                                                stroke="currentColor"
                                            >
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                            </svg>
                                            <div className="flex flex-col">
                                                <span className="text-lg font-medium">{year}</span>
                                            </div>
                                        </div>
                                        <div className="flex gap-2">
                                            {/* <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openAddOperationPopup(yearIndex);
                                                }} 
                                                // className={cn('px-3 py-1 font-medium text-white hover:underline', getOperationData(year) && 'hidden')}
                                                className="px-3 py-1 font-medium text-white hover:underline"
                                            >                                                
                                                + Add Score Chart</button> */}
                                            {/* <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openAddItemPopup(yearIndex);
                                                }}
                                                className="px-3 py-1 font-medium text-white hover:underline"
                                            >
                                                + Add ESG Item
                                            </button> */}
                                            <button
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    // deleteGroup(yearIndex);
                                                    // setItemToDelete(item);
                                                    setYearToDelete(year);
                                                    setShowConfirmation(true);
                                                }}
                                                className="text-gray-400 hover:text-red-500 transition-colors"
                                            >
                                                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {expandedYears[yearIndex] && (
                                    <div className="mt-4 ml-10">
                                        {/* Operation Section */}
                                        <div>
                                            <div 
                                                className="bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] rounded-lg text-white p-3 my-2 flex justify-start items-center gap-4 cursor-pointer"
                                                onClick={() => toggleSection(yearIndex, 'operation')}
                                                // onClick={() => setExpendedOperations(!expendedOperations)}
                                            >
                                                <div className="flex items-center justify-between w-full">
                                                    <div className="flex gap-2">
                                                        <svg 
                                                            className={`w-6 h-6 transition-transform ${expandedSections[`${yearIndex}-operation`] !== false ? 'rotate-180' : ''}`}
                                                            fill="none" 
                                                            viewBox="0 0 24 24" 
                                                            stroke="currentColor"
                                                        >
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                        </svg>
                                                        <h3 className="text-lg font-semibold">Operation</h3>
                                                    </div>

                                                    {hasOperationData(year) ? (
                                                    <div className="flex gap-2">
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleEditOperation(yearIndex);
                                                            }}
                                                            className="text-white hover:text-blue-500 transition-colors"
                                                        >
                                                            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                            </svg>
                                                        </button>
                                                       
                                                    </div>
                                                    ):(
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                openAddOperationPopup(yearIndex);
                                                            }} 
                                                            className="px-3 py-1 font-medium text-white hover:underline"
                                                        >                                                
                                                            + Add Score Chart</button>
                                                    )}
                                                
                                                </div>
                                            </div>
                                           

                                            {expandedSections[`${yearIndex}-operation`] !== false && (
                                                <div>
                                                    {getOperationData(year) ? (
                                                        <div className="grid grid-cols-2 gap-4">
                                                            {Object.entries(getOperationData(year))?.map(([section, data], sectionIndex) => (
                                                                <div key={sectionIndex} className="p-4 border border-gray-100 rounded-lg bg-gray-50 relative mb-4">
                                                                    <div className="absolute left-0 top-0 w-36 h-7 bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] flex items-center justify-center text-white rounded-tl-lg rounded-br-lg">
                                                                        {section.charAt(0).toUpperCase() + section.slice(1)}
                                                                    </div>
                                                                    <div className="grid grid-cols-3 gap-6 mt-3 pl-4">
                                                                        {typeof data === 'object' && Object.entries(data)?.map(([field, value], fieldIndex) => (
                                                                            <div key={fieldIndex}>
                                                                                <p className="mb-1 text-sm font-medium text-gray-700">{field.replace(/([A-Z])/g, ' $1').trim()}</p>
                                                                                <p className="text-gray-600">{value || "N/A"} {value ? "/10" : ""}</p>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="bg-white p-8 text-secondary text-center rounded-lg border border-gray-100 shadow-sm">
                                                            <p className="text-gray-500">No operation data available for {year}</p>
                                                            <p className="text-sm text-gray-400 mt-2">Click the "+ Add Score Chart" button to add data</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>


                                        {/* ESG Section */}
                                        <div className="mb-4">
                                            <div 
                                                className="bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] rounded-lg text-white p-3 flex justify-between items-center gap-4 cursor-pointer"
                                                onClick={() => toggleSection(yearIndex, 'esg')}
                                            >
                                                <div className="flex items-center justify-between gap-2">
                                                    <svg 
                                                        className={`w-6 h-6 transition-transform ${expandedSections[`${yearIndex}-esg`] !== false ? 'rotate-180' : ''}`}
                                                        fill="none" 
                                                        viewBox="0 0 24 24" 
                                                        stroke="currentColor"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                    </svg>
                                                    <h3 className="text-lg font-semibold">ESG</h3>
                                                </div>

                                                <button
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        openAddItemPopup(yearIndex);
                                                    }}
                                                    className="px-3 py-1 font-medium text-white hover:underline"
                                                >
                                                    + Add ESG Item
                                                </button>
                                            </div>
                                            {expandedSections[`${yearIndex}-esg`] !== false && (
                                                <div className="space-y-4 mt-4">
                                                    {getYearData(year)?.items?.length > 0 ? (
                                                        Object.entries(groupItemsByType(getYearData(year)?.items)).map(([type, itemsInType], typeIdx) => (
                                                            <div key={type} className="mb-6">
                                                                {/* Type Header */}
                                                                <div
                                                                    className="flex items-center gap-3 cursor-pointer bg-white px-4 py-2 rounded-md mb-2"
                                                                    onClick={() => setExpandedTypes(prev => ({
                                                                        ...prev,
                                                                        [`${yearIndex}-${type}`]: !prev[`${yearIndex}-${type}`]
                                                                    }))}
                                                                >
                                                                    <svg
                                                                        className={`w-5 h-5 transition-transform ${expandedTypes[`${yearIndex}-${type}`] ? 'rotate-180' : ''}`}
                                                                        fill="none"
                                                                        viewBox="0 0 24 24"
                                                                        stroke="currentColor"
                                                                    >
                                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                                    </svg>
                                                                    <span className="text-lg font-semibold text-vekin">{type}</span>
                                                                </div>
                                                                {/* SubType List */}
                                                                {expandedTypes[`${yearIndex}-${type}`] && (
                                                                    <div className="ml-6 space-y-4">
                                                                        {itemsInType.map((item, itemIndex) => (
                                                                            <div key={item.id} className="relative p-4 my-2 overflow-hidden transition-shadow bg-white border border-gray-100 shadow-md rounded-xl hover:shadow-lg">
                                                                                <div className="absolute top-0 left-0 w-2 bg-gradient-to-b from-blue-500 to-green-500"></div>
                                                                                <div className="absolute top-4 right-4 flex gap-2">
                                                                                    <button
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            // setEditingItem(item);
                                                                                            handleEditItem(yearIndex, item);
                                                                                        }}
                                                                                        // onClick={() => handleEditItem(yearIndex, item)}
                                                                                        className="text-gray-400 hover:text-blue-500 transition-colors"
                                                                                    >
                                                                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                                                        </svg>
                                                                                    </button>
                                                                                    <button
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            setItemToDelete(item);
                                                                                            setYearToDelete(year);
                                                                                            setShowConfirmation(true);
                                                                                        }}
                                                                                        // onClick={() => deleteItem(yearIndex, getYearData(year)?.items.findIndex(i => i.id === item.id))}
                                                                                        className="text-gray-400 hover:text-red-500 transition-colors"
                                                                                    >
                                                                                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                                                        </svg>
                                                                                    </button>
                                                                                    
                                                                                
                                                                                </div>


                                                                               

                                                                                <div
                                                                                    // className="flex items-start justify-between pl-4 cursor-pointer "
                                                                                    className="grid grid-cols-4 gap-3 cursor-pointer "
                                                                                    onClick={() => toggleItem(yearIndex, getYearData(year)?.items.findIndex(i => i.id === item.id))}
                                                                                >
                                                                                    <div className="col-span-2">
                                                                                            <span className="font-medium text-gray-600 text-md">
                                                                                                {(() => {
                                                                                                    const options = getSubOptions(item.esgType);
                                                                                                    const selectedOption = options.find(opt => opt.value === item.subType);
                                                                                                    return selectedOption ? selectedOption.label : item.subType;
                                                                                                })()}
                                                                                            </span>
                                                                                    </div>
                                                                                    <div className="flex justify-end gap-1">
                                                                                        <span className="">Score</span>
                                                                                        <span className="text-gray-300">|</span>
                                                                                        <span className="w-4 text-right">{item.score}</span>
                                                                                    </div>
                                                                                    <div className="grid justify-items-end mr-16">
                                                                                        <svg
                                                                                            className={`w-6 h-6 transition-transform ${expandedItems[`${yearIndex}-${getYearData(year)?.items.findIndex(i => i.id === item.id)}`] ? 'rotate-180' : ''}`}
                                                                                            fill="none"
                                                                                            viewBox="0 0 24 24"
                                                                                            stroke="currentColor"
                                                                                        >
                                                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                                                                        </svg>
                                                                                    </div>
                                                                                </div>


                                                                                {expandedItems[`${yearIndex}-${getYearData(year)?.items.findIndex(i => i.id === item.id)}`] && (
                                                                                    <div className="mt-4 pl-4">
                                                                                        {item.sdGoal && (
                                                                                            <div className="mb-4">
                                                                                                <h4 className="mb-2 font-medium text-gray-700">Sustainable Development Goals</h4>
                                                                                                <div className="flex flex-wrap gap-4">
                                                                                                    {Array.isArray(item.sdGoal) ? (
                                                                                                        [...item.sdGoal].sort((a, b) => a - b).map(goalId => (
                                                                                                            <div key={goalId} className="flex items-start gap-2">
                                                                                                                <img
                                                                                                                    src={`https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-${String(goalId).padStart(2, '0')}.jpg`}
                                                                                                                    alt={`SDG ${goalId}`}
                                                                                                                    className="w-20 h-20 transition-transform transform rounded-lg shadow-md hover:scale-105"
                                                                                                                    onMouseEnter={() => {
                                                                                                                        setTooltip({
                                                                                                                            visible: true,
                                                                                                                            x: 0,
                                                                                                                            y: 0,
                                                                                                                            content: `Goal ${goalId}: ${sdGoals.find(goal => goal.id === goalId)?.name || ''}`,
                                                                                                                        });
                                                                                                                    }}
                                                                                                                    onMouseLeave={() => {
                                                                                                                        setTooltip(prev => ({ ...prev, visible: false }));
                                                                                                                    }}
                                                                                                                />
                                                                                                            </div>
                                                                                                        ))
                                                                                                    ) : (
                                                                                                        <div className="flex items-start gap-2">
                                                                                                            <img
                                                                                                                src={`https://sdgs.un.org/sites/default/files/goals/E_SDG_Icons-${String(item.sdGoal).padStart(2, '0')}.jpg`}
                                                                                                                alt={`SDG ${item.sdGoal}`}
                                                                                                                className="w-20 h-20 transition-transform transform rounded-lg shadow-md hover:scale-105"
                                                                                                                onMouseEnter={() => {
                                                                                                                    setTooltip({
                                                                                                                        visible: true,
                                                                                                                        x: 0,
                                                                                                                        y: 0,
                                                                                                                        content: `Goal ${item.sdGoal}: ${sdGoals.find(goal => goal.id === item.sdGoal)?.name || ''}`,
                                                                                                                    });
                                                                                                                }}
                                                                                                                onMouseLeave={() => {
                                                                                                                    setTooltip(prev => ({ ...prev, visible: false }));
                                                                                                                }}
                                                                                                            />
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                        {item.griStandard && (
                                                                                            <div className="p-4 mb-4 rounded-lg bg-gray-50">
                                                                                                <h4 className="mb-2 font-medium text-gray-700">GRI Standards</h4>
                                                                                                <div className="flex flex-wrap gap-2">
                                                                                                    {Array.isArray(item.griStandard)
                                                                                                        ? item.griStandard.map((standard, idx) => (
                                                                                                            <span
                                                                                                                key={idx}
                                                                                                                className="px-3 py-1 text-sm font-medium bg-blue-100 text-blue-800 rounded-full"
                                                                                                            >
                                                                                                                {standard}
                                                                                                            </span>
                                                                                                        ))
                                                                                                        : <p className="text-gray-600">{item.griStandard}</p>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                        {item.topic_list && item.topic_list.length > 0 && (
                                                                                            <div className="mt-6">
                                                                                                <h4 className="mb-4 font-semibold text-gray-800">Topics</h4>
                                                                                                <div className="space-y-4">
                                                                                                    {item.topic_list.map((topic, topicIndex) => (
                                                                                                        <div
                                                                                                            key={`topic-${topicIndex}`}
                                                                                                            className="p-4 border border-gray-100 rounded-lg bg-gray-50 relative"
                                                                                                        >
                                                                                                            <div className="absolute left-0 top-0 w-7 h-7 bg-gradient-to-r from-[#79C8B0] to-[#1FA37C] flex items-center justify-center text-white font-bold rounded-tl-lg rounded-br-lg">
                                                                                                                {topicIndex + 1}
                                                                                                            </div>
                                                                                                            <div className="grid grid-cols-2 gap-6 mt-3 pl-4">
                                                                                                                <div>
                                                                                                                    <p className="mb-1 text-sm font-medium text-gray-700">Measurement</p>
                                                                                                                    <p className="text-gray-600 break-all whitespace-pre-wrap">{topic.measurement}</p>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <p className="mb-1 text-sm font-medium text-gray-700">Target</p>
                                                                                                                    <p className="text-gray-600 break-all whitespace-pre-wrap">{topic.target}</p>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <p className="mb-1 text-sm font-medium text-gray-700">Achievement</p>
                                                                                                                    <p className="text-gray-600 break-all whitespace-pre-wrap">{topic.target_and_achieved}</p>
                                                                                                                </div>
                                                                                                                <div>
                                                                                                                    <p className="mb-1 text-sm font-medium text-gray-700">Operation Team</p>
                                                                                                                    <p className="text-gray-600 break-all whitespace-pre-wrap">{topic.operation_team}</p>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="bg-white p-8 text-secondary text-center rounded-lg border border-gray-100 shadow-sm">
                                                            <p className="text-gray-500">No ESG data available for {year}</p>
                                                            <p className="text-sm text-gray-400 mt-2">Click the "+ Add ESG Item" button to add data</p>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </>
            )}

            <InfoPopupShowFormData
                isOpen={isNewPopupOpen}
                onClose={() => setIsNewPopupOpen(false)}
                // groups={groups}
                // setGroups={setGroups}
            />

            {currentGroupIndex !== null && (
                <AddItemPopup
                    isOpen={isAddItemPopupOpen}
                    onClose={() => {
                        setIsAddItemPopupOpen(false);
                        setCurrentGroupIndex(null);
                        setEditingItem(null);
                    }}
                    // groupName={groups[currentGroupIndex]?.name || ''}
                    groupYear={listCompany?.years?.[currentGroupIndex] || ''}
                    groupIndex={currentGroupIndex}
                    // groups={groups}
                    // setGroups={setGroups}
                    editItem={editingItem}
                    setSelectedYear={setSelectedYear}
                />
            )}

            {currentGroupIndex !== null && (
                <AddOperationPopup
                    isOpen={isAddOperationPopupOpen}
                    onClose={() => {
                        setIsAddOperationPopupOpen(false);
                        setCurrentGroupIndex(null);
                        setEditingItem(null);
                    }}
                    groupYear={listCompany?.years?.[currentGroupIndex] || ''}
                    groupIndex={currentGroupIndex}
                    editItem={editingItem}
                    setSelectedYear={setSelectedYear}
                    onOperationSubmit={handleOperationSubmit}
                />
            )}

            
            {showConfirmation && (
                <div className="absolute inset-0 z-20 flex items-center justify-center w-full h-screen overflow-hidden bg-black/70">
                    <div className="p-4 bg-white rounded-lg h-50 w-96">
                        <p className="py-2 text-lg font-semibold text-primary">Delete Confirmation</p>
                        <p className="py-2 text-sm text-center">ยืนยันการลบ 
                            {yearToDelete && !itemToDelete ? (
                                <span className="italic font-semibold mx-1"> ข้อมูลสำหรับ {yearToDelete}</span>
                            ) : (
                                <span className="italic font-semibold mx-2">
                                    {(() => {
                                        const options = getSubOptions(itemToDelete?.esgType);
                                        const selectedOption = options?.find(opt => opt?.value === itemToDelete?.subType);
                                        return selectedOption ? selectedOption?.label : itemToDelete?.subType;
                                    })()} 
                                </span>
                            )}
                            ใช่หรือไม่?
                        </p>
                        <div className="flex justify-center gap-8 pt-4">
                            <button
                                className="p-2 px-4 text-white bg-red-600 rounded-lg hover:bg-red-600/80"
                                onClick={() => {
                                    if (itemToDelete && yearToDelete) {
                                        const yearIndex = listCompany?.years?.indexOf(yearToDelete);
                                        const itemIndex = getYearData(yearToDelete)?.items?.findIndex(i => i.id === itemToDelete.id);
                                        if (yearIndex !== -1 && itemIndex !== -1) {
                                            deleteItem(yearIndex, itemIndex);
                                        }
                                    } else if (yearToDelete && !itemToDelete) {
                                        const yearIndex = listCompany?.years?.indexOf(yearToDelete);
                                        if (yearIndex !== -1) {
                                            deleteGroup(yearIndex);
                                        }
                                    }
                                    setShowConfirmation(false);
                                    setItemToDelete(null);
                                    setYearToDelete(null);
                                }}
                            >
                                Delete
                            </button>
                            <button
                                className="p-2 px-4 text-red-400 border-2 rounded-lg border-black-200 hover:border-red-400/80"
                                type="button"
                                onClick={() => {
                                    setShowConfirmation(false);
                                    setItemToDelete(null);
                                    setYearToDelete(null);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

         
            {tooltip.visible && (
                <div
                    className="fixed z-50 px-3 py-2 text-sm text-white bg-gray-800 rounded shadow-lg pointer-events-none"
                    style={{
                        left: tooltip.x + 10,
                        top: tooltip.y - 30,
                        transform: "translateX(-50%)",
                    }}
                >
                    {tooltip.content}
                </div>
            )}

           
        </div>
    );
}
